.editor {
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.editorArea {
	width: 100%;
	min-height: 150px;
	display: grid;
	grid-template-columns: 1fr auto;
	gap: 8px;
}

.editorContent {
	padding: 10px;
	box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.13);
	border-radius: 4px;
	min-height: 150px;

	> * + * {
		margin-top: 0.75em;
	}

	h1 {
		font-size: 20px;
		font-weight: 700;
		margin: 0.5em 0;
		letter-spacing: -0.5px;
		line-height: 1.2;
	}

	h2 {
		font-size: 18px;
		font-weight: 600;
		margin: 0.5em 0;
		letter-spacing: -0.3px;
		line-height: 1.3;
	}

	h3 {
		font-size: 16px;
		font-weight: 600;
		margin: 0.5em 0;
		line-height: 1.4;
	}

	h4 {
		font-size: 15px;
		font-weight: 600;
		margin: 0.5em 0;
		line-height: 1.4;
	}

	h5 {
		font-size: 14px;
		font-weight: 600;
		margin: 0.5em 0;
		line-height: 1.5;
		color: $blackColor;
	}

	h6 {
		font-size: 13px;
		font-weight: 600;
		margin: 0.5em 0;
		line-height: 1.5;
		color: $darkGrey;
	}

	p {
		margin: 0;
		font-size: 16px;
		line-height: 1.6;

		&[class*='is-editor-empty']:first-child::before {
			content: attr(data-placeholder);
			float: left;
			height: 0;
			color: $darkGrey;
			pointer-events: none;
		}
	}

	ul,
	ol {
		padding-left: 20px;
		margin: 0.5em 0;
		font-size: 16px;
	}

	ul {
		list-style-type: disc;
	}

	ol {
		list-style-type: decimal;
	}

	li p {
		margin: 0;
	}

	a {
		color: $activeColor;
		text-decoration: underline;

		&:hover {
			color: $hoverColor;
		}
	}

	blockquote {
		border-left: 3px solid #e0e0e0;
		margin: 0.5em 0;
		padding-left: 1em;
		color: $darkGrey;
		font-size: 16px;
		font-style: italic;
	}

	code {
		background: #f5f5f5;
		padding: 2px 4px;
		border-radius: 3px;
		font-family: 'Monaco', 'Menlo', monospace;
		font-size: 0.9em;
	}

	img {
		max-width: 100%;
		height: auto;
		border-radius: 4px;
	}
}

:focus {
	outline: none;
}

.tiptap {
	&:focus-visible {
		outline: none;
	}
}
